import React from 'react';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import KskButton from 'ksk/styledComponents/components/KskButton/KskButton';
import { kebabCase } from 'lodash';
import { defaultThemeColor } from 'ksk/styledComponents/themes';

const ConfirmationDialog = ({ open, title, message, onConfirm, onDismiss }) => {
  return (
    <Dialog open={open} onClose={onDismiss}>
      <DialogTitle sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: 56,
        height: 56,
        paddingTop: 0,
        paddingBottom: 0,
        backgroundColor: defaultThemeColor,
        color: '#fff',
      }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ paddingTop: '2em', minWidth: '350px' }}>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <KskButton primary icon={faTimes} onClick={onDismiss}
          id={`btn-${kebabCase(title)}-resposta-nao`}
          label="Não"
        />

        <KskButton secondary icon={faCheck} onClick={onConfirm}
          id={`btn-${kebabCase(title)}-resposta-sim`}
          label="Sim"
        />
      </DialogActions>
    </Dialog>
  );
};

const ConfirmationDialogContext = React.createContext({});

const ConfirmationDialogProvider = ({ children }) => {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dialogConfig, setDialogConfig] = React.useState({});

  const openDialog = ({ title, message, actionCallback }) => {
    setDialogOpen(true);
    setDialogConfig({ title, message, actionCallback });
  };

  const resetDialog = () => {
    setDialogOpen(false);
    setDialogConfig({});
  };

  const resolveDialog = (result) => {
    const callback = dialogConfig?.actionCallback;
    resetDialog();

    if (typeof callback === 'function') {
      callback(result);
    }
  };

  const onConfirm = () => {
    resolveDialog(true);
  };

  const onDismiss = () => {
    resolveDialog(false);
  };

  return (
    <ConfirmationDialogContext.Provider value={{ openDialog }}>
      <ConfirmationDialog
        open={dialogOpen}
        title={dialogConfig?.title}
        message={dialogConfig?.message}
        onConfirm={onConfirm}
        onDismiss={onDismiss}
      />
      {children}
    </ConfirmationDialogContext.Provider>
  );
};

const useConfirmationDialog = () => {
  const { openDialog } = React.useContext(ConfirmationDialogContext);

  const getConfirmation = ({ ...options }) =>
    new Promise((resolve) => {
      openDialog({ actionCallback: resolve, ...options });
    });

  return { getConfirmation };
};

export default ConfirmationDialog;
export { ConfirmationDialogProvider, useConfirmationDialog };
